function resizeIframe (evt) {
    if(evt.origin == "https://hitachi.cwsellors.co.uk"){
        if(evt.data > 0){
            document.getElementById("iframe--finance").style.height = evt.data+"px";
        }
    }
}

if (window.addEventListener) {window.addEventListener("message", resizeIframe,false); } else { window.attachEvent("onmessage", resizeIframe); }      

$( window ).on("load", function(){

    if(document.getElementById("view-finance")){
        document.getElementById("view-finance").style.opacity = '';
        /* $('#view-finance').fancybox({
            class: "fancybox-finance",
            toolbar  : false,
            smallBtn : true,
            modal: false,
            iframe : {
                preload : false,
                css : {
                    "max-width" : '600px'
                }
            },
            beforeLoad : function (instance, current) {
                var variantid = $("[data-variant-id]").first().val();
                if($("#financeid").length){
                    variantid = $("#financeid").first().val();
                }
                current.src = current.src + "&variationid="+variantid;
            }
        }); */
    }

});